import { IDirective } from 'angular'
import { HotkeysService } from '../../hotkeys/hotkeys.service'

const COMBO_TO_TOGGLE_LAST_ITEM = 'alt+l'

// TODO: Remove this directive when react_sale_summary rolled out
export const ToggleLastLineItem = (hotkeysService: HotkeysService) => {
  'ngInject'

  return {
    restrict: 'A',
    link(scope, $element) {
      function toggleLastLineItem() {
        const lastLineItem: HTMLElement | null = $element[0].querySelector(
          '.sale-list-item:last-child .li-cell-summary-container'
        )

        if (lastLineItem) {
          lastLineItem.click()
        }
      }

      hotkeysService.add({
        action: () => toggleLastLineItem(),
        combo: COMBO_TO_TOGGLE_LAST_ITEM,
        summary: 'Toggle last line item',
      })

      scope.$on('$destroy', function () {
        hotkeysService.remove(COMBO_TO_TOGGLE_LAST_ITEM)
      })
    },
  } as IDirective
}
